// extracted by mini-css-extract-plugin
export default {"selectAnswerContainer":"RadioButton_selectAnswerContainer__TCULw","customRadio":"RadioButton_customRadio__MCtPC"};